import { render, staticRenderFns } from "./ModalSingleCourseUsageHistory.vue?vue&type=template&id=edd3993a&scoped=true"
import script from "./ModalSingleCourseUsageHistory.vue?vue&type=script&lang=js"
export * from "./ModalSingleCourseUsageHistory.vue?vue&type=script&lang=js"
import style0 from "./ModalSingleCourseUsageHistory.vue?vue&type=style&index=0&id=edd3993a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd3993a",
  null
  
)

export default component.exports